module.exports = __webpack_public_path__ + "static/media/ZEIT.41559731.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currency-icons/ZEIT.svg
// module id = 657
// module chunks = 0